import { AttachmentType } from '../../models/attachment';
import { ProductError, ProductErrorType } from '../../models/error';

export class AttachmentData {
  attachments: Attachment[];
  direction: AttachmentDirection;
  title?: string;

  constructor(data?: AttachmentData) {
    if (data) {
      this.attachments = (data.attachments || []).map(attachment => new Attachment(attachment));
      this.direction = data.direction;
      this.title = data.title;
    } else {
      this.attachments = [];
      this.direction = AttachmentDirection.HORIZONTAL;
      this.title = null;
    }
  }

  static validate(data: AttachmentData, payloadData: any): ProductError[] {
    if (!data || !data.attachments || !data.attachments.length) {
      return [{ type: ProductErrorType.MISSING, property: 'attachments', payload: { ...payloadData } }];
    }
    return data.attachments
      .map((attachment, attachmentIndex) => Attachment.validate(attachment, { ...payloadData, attachmentIndex }))
      .reduce((flattened, subArray) => flattened.concat(subArray));
  }
}

export enum AttachmentDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export class Attachment {
  type: AttachmentType;
  content: string;
  name: string;
  openNewWindow: boolean;

  constructor(attachment?: Attachment) {
    if (attachment) {
      this.type = attachment.type;
      this.content = attachment.content;
      this.name = attachment.name;
      this.openNewWindow = attachment.openNewWindow;
    } else {
      this.type = null;
      this.content = null;
      this.name = null;
    }
  }

  static validate(attachment: Attachment, payloadData: any): ProductError[] {
    return ProductError.validatePrimitiveTypes(attachment, ['type', 'content', 'name']) //
      .map(error => ({ ...error, payload: { ...payloadData } }));
  }
}
